import { Injectable } from '@angular/core';
import { GVars } from '../gvars/gvars';

/*enum EstadosSesion 
{
  SESION_NO_INICIADA = 1,
  INICIANDO_SESION = 2,
  SESION_INICIADA = 3
}*/

@Injectable()
export class Constantes 
{
  //readonly USUARIO_CLIENTE: string = 'CbaSushi2x1';
  //readonly USUARIO_CLIENTE: string = 'CbaDistribuidoraRoger';
  //readonly USUARIO_CLIENTE: string = 'BsAsPraha';
  
  readonly MAX_RESOLUCION_MOBILE_PX: number = 600;
  readonly MIN_LONG_PASSWORD: number = 8;
  readonly DISPOSITIVO_DESKTOP: number = 0;
  readonly DISPOSITIVO_MOBILE : number = 1; 

  readonly COOKIE_UUID: string = 'uuid';
  readonly COOKIE_DURACION_DIAS: number = 365;

  readonly NO_ESPEC_TEXTO: string = 'No espec.'

  readonly TODOS_LOS_PEDIDOS_TITULO: string = 'Todos';
  readonly PEDIDOS_NUEVOS_TITULO: string = 'Nuevos';
  readonly PEDIDOS_EN_PREPARACION_TITULO: string = 'En preparación'
  readonly PEDIDOS_PARA_ENTREGAR_TITULO: string = 'Para entregar'
  readonly PEDIDOS_ENTREGADOS_TITULO: string = 'Entregados'
  readonly PEDIDOS_RECHAZADOS_TITULO: string = 'Rechazados'

  readonly AGUARDE_POR_FAVOR_TEXTO: string = 'Aguarde por favor. . .';

  readonly EstadoPedido = 
  {
    EPP_REGISTRADO : 0,
	  EPP_DERIVADO : 1,
	  EPP_PRODUCCION : 2,
	  EPP_LISTO_ENTREGA : 3,
	  EPP_DELIVERY : 4,
	  EPP_ENTREGADO : 5,
	  EPP_RECHAZADO : 6
  };

  constructor()
  {
  }
}
